import { Box, IconButton, Typography } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";

const MyMagicPanelShell = ({
  title,
  titleContent,
  headerActions,
  footerLeft,
  footerRight,
  onClose,
  children,
}) => (
  <Box
    sx={{
      height: "100%",
      display: "flex",
      flexDirection: "column",
      backgroundColor: "#FFFFFF",
      border: "1px solid #E5E7EB",
      borderRadius: 1,
      overflow: "hidden",
    }}
  >
    <Box
      sx={{
        px: 1.5,
        py: 0.75,
        minHeight: 40,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        borderBottom: "1px solid #E5E7EB",
        backgroundColor: "#FFFFFF",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, minWidth: 0, flex: 1 }}>
        {titleContent || (
          <Typography sx={{ fontSize: 13, fontWeight: 600, color: "text.primary", whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" }}>
            {title}
          </Typography>
        )}
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
        {headerActions}
        {onClose && (
          <IconButton size="small" onClick={onClose} aria-label="Close panel">
            <CloseIcon sx={{ fontSize: 16 }} />
          </IconButton>
        )}
      </Box>
    </Box>

    <Box sx={{ flex: 1, minHeight: 0, overflow: "auto" }}>{children}</Box>

    <Box
      sx={{
        px: 1.5,
        py: 0.5,
        minHeight: 28,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1,
        borderTop: "1px solid #E5E7EB",
        backgroundColor: "#FFFFFF",
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        {typeof footerLeft === "string" ? (
          <Typography sx={{ color: "text.secondary", fontSize: 11 }}>{footerLeft}</Typography>
        ) : (
          footerLeft
        )}
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>{footerRight}</Box>
    </Box>
  </Box>
);

export default MyMagicPanelShell;
